import { WhatsappConnectionCard } from "@/components/connections/WhatsappConnectionCard";
import { TelegramConnectionCard } from "@/components/connections/TelegramConnectionCard";

/** Passo 2: conecta a conta que monitora e reenvia (mesmos cards de Integracoes). */
export function StepCanal(): JSX.Element {
  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">
        Conecte pelo menos uma conta. É ela que lê os grupos de origem e publica as ofertas convertidas nos
        seus destinos. Dá para conectar a outra depois em Integrações.
      </p>
      <WhatsappConnectionCard />
      <TelegramConnectionCard />
    </div>
  );
}
